import "@/main/i18n/config";
import React from "react";
import { Router, Routes } from "./routes";
import { ReverbUITheme, ThemeProvider } from "@reverb-ui/react";
export var App = function () { return (React.createElement("section", { "data-testid": "app-component" },
    React.createElement(ThemeProvider, { theme: ReverbUITheme, resetCSS: true },
        React.createElement(Router, null,
            React.createElement(Routes, null))))); };
export default App;
